import { FunctionComponent } from 'react';
import TitleWithIcon from '../../../../../components/titles/TitleWithIcon/TitleWithIcon';
import { ReactComponent as LayersIcon } from '../../../../../asset/images/icons/layers.svg';
import { ReactComponent as CdLogo } from '../../../../../apps/constellationDinners/asset/images/constellation_dinners_logo.svg';
import { ReactComponent as ArrowIcon } from '../../../../../asset/images/button_arrow.svg';
import styles from './AccountAppsDetail.module.scss';
import MetaTags from '../../../../../components/seo/MetaTags/MetaTags';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { RoutesGrouped } from '../../../../../data/routes';
import MainButton from '../../../../../components/buttons/MainButton/MainButton';
import NavigationLink from '../../../../../components/links/NavigationLink/NavigationLink';

interface AccountSubscriptionProps {}

const AccountAppsDetail: FunctionComponent<AccountSubscriptionProps> = () => {
  const navigate = useNavigate();

  return (
    <div className={styles['apps']}>
      <MetaTags title="Account - Apps - Detail" />

      <NavigationLink
        className={styles['back-link']}
        path="/account/apps"
        iconLeft={<ArrowIcon style={{ transform: 'rotate(180deg)' }} />}
        withBorder={false}
      >
        Back to Apps
      </NavigationLink>

      <h3 className={classNames(styles['title'], 'text text--h3')}>Constellation Dinners</h3>

      <div className="bottom-part">
        <p className={classNames(styles['text'], 'text text--body-2')}>
          Sign up to attend 6-person founder/investor dinners in your city where each guest is matched by relevant
          business types, industries, and revenue stages. Follow up 1:1 afterwards to foster authentic relationships
          that lead to new business, investments, and camaraderie.
        </p>

        <MainButton className={styles['button']} onClick={() => alert('Test')}>
          Add app
        </MainButton>
      </div>
    </div>
  );
};

export default AccountAppsDetail;
